"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/label-has-associated-control */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const assets_1 = require("~/assets");
const UI_1 = require("~/components/UI");
const routes_1 = require("~/consts/routes");
const react_helmet_async_1 = require("react-helmet-async");
const AuthorizationForm_module_scss_1 = __importDefault(require("../../AuthorizationForms/AuthorizationForm.module.scss"));
function RestorePasswordDefault({ onSubmit }) {
    const { t } = (0, react_i18next_1.useTranslation)('authorization');
    const [email, setEmail] = (0, react_1.useState)({
        value: '',
        error: null,
    });
    const [isEmailSend, setIsEmailSend] = (0, react_1.useState)(false);
    const [isEmailValid, setIsEmailValid] = (0, react_1.useState)(false);
    return (react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.container },
        react_1.default.createElement(react_helmet_async_1.Helmet, null,
            react_1.default.createElement("title", null, "Restore Password | TBUILD")),
        react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.headline },
            t('headline.restore-password.main'),
            react_1.default.createElement("div", null, t('headline.restore-password.subtitle'))),
        react_1.default.createElement("form", null,
            react_1.default.createElement("label", null,
                " ",
                t('email.title')),
            react_1.default.createElement(UI_1.Input, { type: "email", maxLength: 255, placeholder: t('email.placeholder'), value: email.value, onChange: (value, error) => {
                    setEmail({ value, error });
                    setIsEmailValid(value.trim() !== '' && !error);
                }, onInput: (value, error) => {
                    setEmail({ value, error });
                    setIsEmailValid(value.trim() !== '' && !error);
                }, required: true }),
            react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.footer },
                react_1.default.createElement(UI_1.Button, { wide: true, variant: "primary", onClick: (event) => {
                        event.preventDefault();
                        onSubmit(email.value);
                        setIsEmailSend(true);
                    }, disabled: !isEmailValid }, !isEmailSend ? t('button.get-link') : t('button.resend')),
                t('headline.restore-password.bottom'),
                react_1.default.createElement("div", { className: AuthorizationForm_module_scss_1.default.bottomlink },
                    react_1.default.createElement(react_router_dom_1.Link, { to: routes_1.ROUTE_LOGIN },
                        react_1.default.createElement("img", { src: assets_1.svgSystemChevronLeft, alt: "" }),
                        t('button.back-to-sign-in')))))));
}
exports.default = RestorePasswordDefault;
